import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useQueryClient } from '@tanstack/react-query';
import Alert from 'components/Alert';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDesactiveProductOffer } from 'v2/hooks/useDesactiveProductOffer';

import type { ProductOffer } from 'v2/interfaces/product';

import type IProduct from 'interfaces/IProduct';

type ActionsMenuProps = {
  anchorEl: null | HTMLElement;
  hasUnsavedChanges: boolean;
  product: IProduct;
  offer: ProductOffer;
  closeMenu: () => void;
  openLinksModal: () => void;
  openConfirmModal: (cancelModalCallback?: undefined | (() => void)) => void;
};

function ActionsMenu({ anchorEl, openLinksModal, closeMenu, product, offer, hasUnsavedChanges, openConfirmModal }: ActionsMenuProps) {
  const queryClient = useQueryClient();
  const history = useHistory();
  const desactiveOfferMutation = useDesactiveProductOffer({
    onSuccess: () => {
      toast.success('Oferta excluída com sucesso!');
      closeMenu();
      queryClient.invalidateQueries(['products', product.id, 'offers']);
    },
    onError: () => {
      toast.error('Ocorreu um erro ao excluir a oferta! Tente novamente.');
    },
  });

  function handleLinksClick() {
    closeMenu();
    openLinksModal();
  }

  function navigateToEditOffer() {
    history.push(`/producer/product/${product.id}/offers/${offer?.id}/edit`, {
      product,
      offer,
    });
  }

  function handleEditClick() {
    if (hasUnsavedChanges) {
      closeMenu();
      openConfirmModal(navigateToEditOffer);
      return;
    }

    navigateToEditOffer();
  }

  async function handleDeleteClick() {
    const confirm = await Alert.confirm({
      title: 'Confirmação de exclusão',
      message: 'Tem certeza que deseja excluir esta oferta?',
      confirmation: true,
      buttonOk: 'Excluir',
      buttonCancel: 'Cancelar',
    });

    if (confirm) {
      toast.info('Excluindo oferta...');
      await desactiveOfferMutation.mutateAsync({
        productId: product.id,
        offerId: offer?.id,
      });
    }
  }

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
      <MenuItem id='edit-offer-button' onClick={handleEditClick}>
        Editar
      </MenuItem>
      <MenuItem id='links-offer-button' onClick={handleLinksClick}>
        Links desta oferta
      </MenuItem>
      {!offer?.is_default && (
        <MenuItem id='delete-offer-button' onClick={handleDeleteClick}>
          Excluir
        </MenuItem>
      )}
    </Menu>
  );
}

export { ActionsMenu };
